<template>
  <div id="calendar_customer_widget" class="calendar-event-table-component" :class="{ loaded: !loading }">
    <table v-if="loading" class="table">
      <tbody>
      <tr>
        <td class="column1">
          <Skeleton class="skeleton" :loading="true"></Skeleton>
        </td>
        <td class="column2">
          <Skeleton class="skeleton" :loading="true"></Skeleton>
        </td>
        <td class="column3 text-end">
          <Skeleton class="skeleton" :loading="true"></Skeleton>
        </td>
      </tr>
      </tbody>
    </table>

    <table v-else class="table">
      <template v-if="hasEvents">
        <calendar-event-table-row-component
            v-for="event in events.data"
            :key="event.id"
            :event="event"
            @event-updated="handleEventUpdated"
            @event-deleted="handleEventDeleted(event.id)">
        </calendar-event-table-row-component>
      </template>
      <tbody v-else>
      <tr>
        <td class="no-appointments">Er zijn geen afspraken voor deze klant.</td>
      </tr>
      </tbody>
    </table>

    <!--      TODO: lege ruimte als geen paginatie? -->

    <div v-if="displayPagination" class="panel-body">
      <laravel-pagination
          :data="events"
          @pagination-change-page="loadPaginatedEvents"
          :size="'small'">
      </laravel-pagination>
    </div>

    <div class="panel-footer">
      <a class="btn btn-primary" id="create-new-calendar-event-button" @click="showCreateModal = true">Nieuwe
        afspraak</a>
    </div>

    <modal-create-or-edit-component :is-new-event="showCreateModal"
                                    :customer-id="customerId"
                                    @close="closeModal"
                                    @update="handleEventUpdated"/>

  </div>
</template>

<script>
import ModalCreateOrEditComponent from "./ModalCreateOrEditComponent.vue";
import CalendarEventTableRowComponent from './RowComponent.vue';
import CreateOrEditAppointmentComponent from './CreateOrEditAppointmentComponent.vue';
import CreateOrEditCalendarEventComponent from './CreateOrEditComponent.vue';
import calendarEventApi from '~/api/calendar_event';
import {Skeleton} from 'vue-loading-skeleton';

export default {
  name: "CalendarEventTableComponent",
  components: {
    ModalCreateOrEditComponent,
    CalendarEventTableRowComponent,
    CreateOrEditAppointmentComponent,
    CreateOrEditCalendarEventComponent,
    Skeleton
  },
  props: {
    customerId: {
      type: [Number, String],
      required: true,
    }
  },
  data() {
    return {
      loading: true,
      events: {},
      showCreateModal: false,
    }
  },
  mounted() {
    this.loadPaginatedEvents(1);
  },
  computed: {
    displayPagination() {
      return typeof this.events.meta !== "undefined";
    },
    hasEvents() {
      return (this.events.data && this.events.data.length > 0);
    }
  },
  methods: {
    loadPaginatedEvents(page = 1, perPage = 10) {
      this.loading = true;
      calendarEventApi.paginateForFamilyByCustomer(this.customerId, page, perPage, ['customer'])
          .then(response => {
            this.events = response;
          }).catch(() => {
        this.$notification['error']({
          message: 'Het is niet gelukt de afspraken te laden.',
        })
      }).finally(() => this.loading = false);
    },
    handleEventUpdated() {
      this.showCreateModal = false;
      this.loadPaginatedEvents();
    },
    handleEventDeleted(id) {
      this.events.data = this.events.data.filter(event => event.id !== id);
    },
    closeModal() {
      this.showCreateModal = false;
    }
  },
};
</script>

<style scoped>
.skeleton {
  margin: 0 !important;
  padding: 0 !important;
  border-color: rgb(217, 217, 217);
  border-radius: 4px;
  height: 30px;
}

.column1 {
  width: 240px;
}

.column2 {
  width: 60px;
}

.column3 {
  width: 20px;
}
</style>
